// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/export-styles */
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import * as React from "react";

type Props = TypographyPresentationProps & {
    unitOfMeasure: DistanceUnitOfMeasure;
    distance: number;
    overrideTitle?: string;
};

export type DistanceUnitOfMeasure = "Imperial" | "Metric";

const DistanceDisplay: React.FC<Props> = ({ unitOfMeasure, distance, overrideTitle, ...otherProps }) => {
    const unit = unitOfMeasure === "Imperial" ? translate("mi") : translate("km");

    if (unitOfMeasure === "Metric") {
        distance = distance * 1.60934;
    }

    const value = (overrideTitle || translate("Distance {0} {1}"))
        .replace("{0}", `${distance.toFixed(distance < 100 ? 2 : 0)}`)
        .replace("{1}", unit);

    return (
        <Typography
            {...otherProps}
            style={{
                fontSize: 12,
                fontWeight: "bold",
                lineHeight: "15px",
            }}
        >
            {value}
        </Typography>
    );
};

export default DistanceDisplay;
